import { BindAll } from 'lodash-decorators'
import { PagePagination } from '@xt/client/utils/infinite-loading/index'
import { EnumApiMy, EnumBishan } from '@xt/client/api'
import type { BishanResponse, BishanExpiredResponse } from '@xt/client/entities/my-v2/types.d'
import { $service } from '@xt/client/experimental/request/service'
import { reportEntryLog } from '@xt/client/utils/log'
import { action, observable, computed } from 'mobx'
import moment from 'moment'

@BindAll()
export class MyAccountBishanController {
  @observable expireBishan: BishanExpiredResponse | null = null
  @observable hasRead: boolean = false

  pagePagination = new PagePagination<BishanResponse>({
    url: EnumApiMy.MyPointsBiShan,
    pageSize: 20
  })

  @computed
  get isShowExpireBishan() {
    return (
      this.expireBishan &&
      !this.hasRead &&
      [this.expireBishanPopText, this.expireBishanAccountText].some(Boolean) &&
      this.expireBishan.isShow === 1
    )
  }

  @computed
  get expireBishanPopText() {
    if (!this.expireBishan || this.expireBishan.bishanNum === null || this.expireBishan.expireTime === null) return ''

    return `你有 ${this.expireBishan.bishanNum} 个笔山即将在 ${moment(this.expireBishan.expireTime).format('YYYY年MM月DD日')} 过期失效，记得尽快兑换哦～`
  }

  @computed
  get expireBishanAccountText() {
    if (!this.expireBishan || this.expireBishan.bishanNum === null || this.expireBishan.expireTime === null) return ''

    return `预计有 ${this.expireBishan.bishanNum} 积分将于 ${moment(this.expireBishan.expireTime).format('YYYY-MM-DD')} 失效`
  }

  // 过期提醒已读操作
  async hasReadTooltip() {
    try {
      const [err, res] = await $service({
        url: EnumBishan.READ
      })

      if (err) throw err

      if (res === true) {
        this.setHasRead(true)
      }
    } catch (error) {
      reportEntryLog('account.expire-bishan-read.fail', { error })
    }
  }

  // 获取过期笔山数据
  async getExpireTime() {
    try {
      const [err, res] = await $service<BishanExpiredResponse>({
        url: EnumBishan.EXPIRE_TIP
      })

      if (err) throw err

      this.setExpireBishan(res)
    } catch (error) {
      reportEntryLog('account.loading-bishan-expire.fail', { error })
    }
  }

  @action
  setHasRead(read: boolean) {
    this.hasRead = read
  }

  @action
  setExpireBishan(res: BishanExpiredResponse) {
    this.expireBishan = {
      ...res
    }
  }

  @action
  reset() {
    this.expireBishan = null
    this.hasRead = false
  }
}
